import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePartyInputClass;
function SavePartyInput() {
  if (SavePartyInputClass === VOID) {
    class $ {
      constructor(partyId, name, email, pairingRule, badgesEnabled, defaultBadgeName, alternateBadgeName, callSignsEnabled, animationsEnabled, animationSpeed) {
        name = name === VOID ? Absent_getInstance() : name;
        email = email === VOID ? Absent_getInstance() : email;
        pairingRule = pairingRule === VOID ? Absent_getInstance() : pairingRule;
        badgesEnabled = badgesEnabled === VOID ? Absent_getInstance() : badgesEnabled;
        defaultBadgeName = defaultBadgeName === VOID ? Absent_getInstance() : defaultBadgeName;
        alternateBadgeName = alternateBadgeName === VOID ? Absent_getInstance() : alternateBadgeName;
        callSignsEnabled = callSignsEnabled === VOID ? Absent_getInstance() : callSignsEnabled;
        animationsEnabled = animationsEnabled === VOID ? Absent_getInstance() : animationsEnabled;
        animationSpeed = animationSpeed === VOID ? Absent_getInstance() : animationSpeed;
        this.n6o_1 = partyId;
        this.o6o_1 = name;
        this.p6o_1 = email;
        this.q6o_1 = pairingRule;
        this.r6o_1 = badgesEnabled;
        this.s6o_1 = defaultBadgeName;
        this.t6o_1 = alternateBadgeName;
        this.u6o_1 = callSignsEnabled;
        this.v6o_1 = animationsEnabled;
        this.w6o_1 = animationSpeed;
      }
      toString() {
        return 'SavePartyInput(partyId=' + this.n6o_1.toString() + ', name=' + toString(this.o6o_1) + ', email=' + toString(this.p6o_1) + ', pairingRule=' + toString(this.q6o_1) + ', badgesEnabled=' + toString(this.r6o_1) + ', defaultBadgeName=' + toString(this.s6o_1) + ', alternateBadgeName=' + toString(this.t6o_1) + ', callSignsEnabled=' + toString(this.u6o_1) + ', animationsEnabled=' + toString(this.v6o_1) + ', animationSpeed=' + toString(this.w6o_1) + ')';
      }
      hashCode() {
        var result = this.n6o_1.hashCode();
        result = imul(result, 31) + hashCode(this.o6o_1) | 0;
        result = imul(result, 31) + hashCode(this.p6o_1) | 0;
        result = imul(result, 31) + hashCode(this.q6o_1) | 0;
        result = imul(result, 31) + hashCode(this.r6o_1) | 0;
        result = imul(result, 31) + hashCode(this.s6o_1) | 0;
        result = imul(result, 31) + hashCode(this.t6o_1) | 0;
        result = imul(result, 31) + hashCode(this.u6o_1) | 0;
        result = imul(result, 31) + hashCode(this.v6o_1) | 0;
        result = imul(result, 31) + hashCode(this.w6o_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePartyInput()))
          return false;
        if (!this.n6o_1.equals(other.n6o_1))
          return false;
        if (!equals(this.o6o_1, other.o6o_1))
          return false;
        if (!equals(this.p6o_1, other.p6o_1))
          return false;
        if (!equals(this.q6o_1, other.q6o_1))
          return false;
        if (!equals(this.r6o_1, other.r6o_1))
          return false;
        if (!equals(this.s6o_1, other.s6o_1))
          return false;
        if (!equals(this.t6o_1, other.t6o_1))
          return false;
        if (!equals(this.u6o_1, other.u6o_1))
          return false;
        if (!equals(this.v6o_1, other.v6o_1))
          return false;
        if (!equals(this.w6o_1, other.w6o_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePartyInput');
    SavePartyInputClass = $;
  }
  return SavePartyInputClass;
}
//region block: exports
export {
  SavePartyInput as SavePartyInput3ikp23en56cie,
};
//endregion

//# sourceMappingURL=SavePartyInput.mjs.map
